// DialogSetting Component

/* eslint react/jsx-handler-names:0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import Avatar from '../../../common/common/avatar/avatar.jsx'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import Util from '../../../lib/util.jsx'

class DialogSetting extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }

    this.data = {
      invoice: []
    }

    this._references = {
      confirmDelete: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onEdit: PropTypes.func,
      onDelete: PropTypes.func,
      onClose: PropTypes.func,
      onViewPdf: PropTypes.func,
      onMarkAsPaid: PropTypes.func,
      onCopyInvoice: PropTypes.func,
      onCreditNote: PropTypes.func,
      onSendMail: PropTypes.func,
      downloadUrl: PropTypes.string,
      isSupportUser: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onEdit: null,
      onDelete: null,
      onClose: null,
      onViewPdf: null,
      onMarkAsPaid: null,
      onCopyInvoice: null,
      onCreditNote: null,
      onSendMail: null,
      downloadUrl: ''
    }
  }

  show (invoice) {
    if (invoice) {
      this.data.invoice = invoice
    }

    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    this.data.invoice = []
    FabButtonManager.setVisible(true)
    this.setState({ active: false })
  }

  render () {
    const invoice = this.data.invoice

    let title = IntlUtil.convertMessage('invoice.list.invoiceDraft')
    if (invoice && invoice.invoiceNo) {
      title = invoice.invoiceNo
    }

    return (
      <Dialog
        active={this.state.active}
        onClose={this._onClose.bind(this)}
        modal
        className='dialog-invoicesetting'
      >
        {invoice.imageUrl && (
          <div className='itemheader'>
            <Avatar imageUrl={invoice.imageUrl} title={invoice.firstName} />
          </div>
        )}
        <div className='dialog-actionboard'>
          <div className='actionboard-section'>
            <div className='actionboard-row'>
              <div className='actionboard-col'>
                <div className='msg'>{invoice.title}</div>
                <div className='title'>{title}</div>
                <div className='split' />
                {this._renderInfo()}
              </div>
            </div>
          </div>
          <div className='actionboard-footer'>
            <div className='actionboard-row act-row'>
              {this._renderActions()}
            </div>

            <ConfirmDelete
              ref={this._references.confirmDelete}
              title='invoice.list.msgOnDelete'
              onClickOk={this._onClickDeleteConfirm.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  _renderInfo () {
    const invoice = this.data.invoice
    const _className = classnames('dueinfo', `${invoice.status}`.toLowerCase())

    if (invoice.status === 'Paid') {
      return (
        <div className={_className}>
          <IntlMessage ident='invoice.list.statusPaid' />
        </div>
      )
    } else if (invoice.status === 'Overdue' || invoice.status === 'Final') {
      return (
        <div className={_className}>
          {DateUtil.displayHumanized(invoice.invoiceDate)}
        </div>
      )
    } else if (invoice.status === 'Draft') {
      return (
        <div className={_className}>
          <IntlMessage ident='invoice.list.statusDraft' />
        </div>
      )
    }

    return ''
  }

  _renderActions () {
    const { invoice } = this.data
    const actions = this._getActions()
    const invoiceId = invoice ? invoice.id : ''
    const invoiceStatus = invoice.status ? invoice.status : ''
    let pdfFileName = ''
    if (invoice) {
      pdfFileName = Util.getPdfFileName(
        'invoice',
        invoice.invoiceNo,
        invoiceStatus
      )
    }

    return actions.map((action, idx) => {
      if (!action.href) {
        return (
          <div
            className='actionboard-col2 alert-col2'
            key={idx}
            id={action.id ? action.id : ''}
          >
            <div className='action-btn' onClick={action.handler}>
              <Button
                icon={action.icon}
                className={action.className}
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident={action.title} />
              </span>
            </div>
          </div>
        )
      }

      return (
        <a
          className='actionboard-col2 alert-col2'
          key={idx}
          href={encodeURI(`${action.href}/${invoiceId}/false/${pdfFileName}`)}
          target='_blank'
          rel='noopener noreferrer'
        >
          <div className='action-btn'>
            <Button
              icon={action.icon}
              className={action.className}
              canHover={false}
            />
            <span className='label'>
              <IntlMessage ident={action.title} />
            </span>
          </div>
        </a>
      )
    })
  }

  _getActions () {
    const actions = []
    const status = this.data.invoice.status

    if (status === 'Draft') {
      actions.push({
        title: 'invoice.list.actionEdit',
        icon: 'action-edit',
        handler: this._onEdit.bind(this),
        className: 'button_dialog'
      })
    }

    if (status === 'Draft' || this.props.isSupportUser) {
      actions.push({
        title: 'invoice.list.actionDelete',
        icon: 'action-delete',
        handler: this._onDelete.bind(this),
        className: 'button_dialog button_dialogdlt'
      })
    }

    actions.push({
      title: 'invoice.list.actionViewPdf',
      icon: 'action-download',
      className: 'button_dialog',
      href: this.props.downloadUrl
    })

    actions.push({
      id: 'options-copy-invoice',
      title: 'invoice.list.actionCopyInvoice',
      icon: 'action-copy',
      handler: this._onCopyInvoice.bind(this),
      className: 'button_dialog'
    })

    actions.push({
      title: 'invoice.list.actionSendMail',
      icon: 'header-mail',
      handler: this._onSendMail.bind(this),
      className: 'button_dialog'
    })

    if (status === 'Overdue' || status === 'Final') {
      actions.push({
        title: 'invoice.list.actionMarkAsPaid',
        icon: 'action-approve',
        handler: this._onMarkAsPaid.bind(this),
        className: 'button_dialog'
      })
    }

    if (status !== 'Draft' && !this.data.invoice.isCredit) {
      actions.push({
        title: 'invoice.list.actionCreditNote',
        icon: 'action-credit',
        handler: this._onCreditNote.bind(this),
        className: 'button_dialog'
      })
    }

    return actions
  }

  _onClickDeleteConfirm (e) {
    e.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete(this.data.invoice)
    }
  }

  _onEdit (ev) {
    ev.preventDefault()

    if (this.props.onEdit) {
      this.props.onEdit(this.data.invoice)
    }
  }

  _onDelete (ev) {
    ev.preventDefault()
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onViewPdf (ev) {
    ev.preventDefault()
  }

  _onCopyInvoice (ev) {
    ev.preventDefault()

    if (this.props.onCopyInvoice) {
      this.props.onCopyInvoice(this.data.invoice)
    }
  }

  _onClose (_ev) {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  _onSendMail (ev) {
    ev.preventDefault()

    if (this.props.onSendMail) {
      this.props.onSendMail(this.data.invoice)
    }
  }

  _onMarkAsPaid (ev) {
    ev.preventDefault()

    if (this.props.onMarkAsPaid) {
      this.props.onMarkAsPaid(this.data.invoice)
    }
  }

  _onCreditNote (ev) {
    ev.preventDefault()

    if (this.props.onCreditNote) {
      this.props.onCreditNote(this.data.invoice)
    }
  }
}

export default DialogSetting
